export * from './series-list/series-list.component';
export * from './season-list/season-list.component';
export * from './episode-carousel/episode-carousel.component';
export * from './series-spotlight/series-spotlight.component';
export * from './detail-view/detail-view.component';
export * from './vdgm-select/vdgm-select.component';
export * from './detail-view/detail-view.component';
export * from './vdgm-date-picker/vdgm-date-picker.component';



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/index.ts